import { LoaderFunctionArgs, redirect } from 'react-router';

import { clearExternalInvitations } from '@/domain/external-invitation/actions/clear-extenal-invitations.action';
import { getExternalInvitations } from '@/domain/external-invitation/actions/get-external-invitations.action';
import { getImpactCalculateVenueCo2ForProject } from '@/domain/impact-calculate-venue/actions/get-impact-calculate-venue-co2-for-project.action';
import { getSummaryImpactCalculateVenueForAllProjects } from '@/domain/impact-calculate-venue/actions/get-summary-impact-calculate-venue-for-all-projects.action';
import { runImpactCalculateVenueEnvForProject } from '@/domain/impact-calculate-venue/actions/run-impact-calculate-venue-env-for-project.action';
import { runImpactCalculateVenueEssForProject } from '@/domain/impact-calculate-venue/actions/run-impact-calculate-venue-ess-for-project.action';
import { clearImpactCo2Answers } from '@/domain/impact-co2/actions/clear-impact-co2-answers.action';
import { getImpactCo2Answers } from '@/domain/impact-co2/actions/get-impact-co2-answers.action';
import { getImpactEnvQuestions } from '@/domain/impact-env/actions/get-impact-env-questions.action';
import { getImpactEnvResponses } from '@/domain/impact-env/actions/get-impact-env-responses.action';
import { getImpactEssQuestions } from '@/domain/impact-ess/actions/get-impact-ess-questions.action';
import { getImpactEssResponses } from '@/domain/impact-ess/actions/get-impact-ess-responses.action';
import { projectSlice } from '@/domain/project/project.slice';
import { clearCurrentProjectVenue } from '@/domain/project-venue/actions/clear-current-project-venue.action';
import { getProjectVenue } from '@/domain/project-venue/actions/get-project-venue.action';
import { getProjectsVenue } from '@/domain/project-venue/actions/get-projects-venue.action';
import { clearProjectVenueDates } from '@/domain/project-venue-dates/actions/clear-venue-dates.action';
import { getVenueDates } from '@/domain/project-venue-dates/actions/get-venue-dates.action';
import { clearProjectVenueMonthDeclaration } from '@/domain/project-venue-month-declaration/actions/clear-month-declaration.action';
import { getMonthDeclarations } from '@/domain/project-venue-month-declaration/actions/get-month-declaration.action';
import { getVenuePresets } from '@/domain/project-venue-presets/actions/get-venue-presets.action.ts';
import { store } from '@/domain/store';
import { prepareAuth } from '@/ui/navigation/loaders/prepare-auth-loader';

import { makeCommonGets } from '../appLoaders';

export async function venueIndexLoader() {
  await store.dispatch(projectSlice.actions.changeMode('venue'));
  return null;
}

export async function venuesLoader() {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return null;
  }
  makeCommonGets();
  store.dispatch(getProjectsVenue());
  store.dispatch(getSummaryImpactCalculateVenueForAllProjects());
  store.dispatch(clearCurrentProjectVenue());
  store.dispatch(clearExternalInvitations());
  store.dispatch(clearProjectVenueDates());
  store.dispatch(clearProjectVenueMonthDeclaration());
  return null;
}

export async function presetsLoader({ params }: LoaderFunctionArgs) {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return null;
  }
  makeCommonGets();
  const projectId = parseInt(params.id as string);
  await store.dispatch(getProjectVenue(projectId));
  store.dispatch(getVenueDates());
  store.dispatch(getVenuePresets());
  return null;
}

export async function venueLoader({ params }: LoaderFunctionArgs) {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return null;
  }
  makeCommonGets();
  const projectId = parseInt(params.id as string);
  await store.dispatch(getProjectVenue(projectId));
  store.dispatch(getVenueDates());
  store.dispatch(getImpactCalculateVenueCo2ForProject({ projectId })); // co2 : just get results, do not need to run calculate
  // store.dispatch(runImpactCalculateVenueEnvForProject({ projectId }));
  // store.dispatch(runImpactCalculateVenueEssForProject({ projectId }));
  store.dispatch(clearExternalInvitations());
  return null;
}

export async function venueStructureLoader({ params }: LoaderFunctionArgs) {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return null;
  }
  makeCommonGets();
  const projectId = parseInt(params.id as string);
  await store.dispatch(getProjectVenue(projectId));
  store.dispatch(getExternalInvitations({ projectId }));
  store.dispatch(clearImpactCo2Answers());
  store.dispatch(getImpactCo2Answers({ projectId }));
  store.dispatch(getImpactEnvQuestions());
  store.dispatch(getImpactEnvResponses({ projectId }));
  store.dispatch(getImpactEssQuestions({}));
  store.dispatch(getImpactEssResponses({ projectId }));
  store.dispatch(getImpactCalculateVenueCo2ForProject({ projectId })); // co2 : just get results, do not need to run calculate
  store.dispatch(runImpactCalculateVenueEnvForProject({ projectId }));
  store.dispatch(runImpactCalculateVenueEssForProject({ projectId }));
  return null;
}

export async function venueDatesLoader({
  params,
  request,
}: LoaderFunctionArgs) {
  const { userIsConnected } = await prepareAuth();
  if (!userIsConnected) {
    return null;
  }
  makeCommonGets();
  const projectId = parseInt(params.id as string);
  const project = await store.dispatch(getProjectVenue(projectId)).unwrap();
  store.dispatch(getMonthDeclarations({ projectId }));
  const presets = await store.dispatch(getVenuePresets()).unwrap();
  store.dispatch(getVenueDates());
  if (!request.url.includes('force=true')) {
    if (project && presets.length === 0) {
      return redirect(`/app/projects/venue/${project.id}/default-datas`);
    }
  }
  store.dispatch(getImpactCalculateVenueCo2ForProject({ projectId })); // co2 : just get results, do not need to run calculate
  return null;
}
